<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
            for="excmcaruserdata_car"
            class="form-control-label">{{$t('views.excmcaruserdata.form.car')}}:</label>
<!--          <input-->
<!--            id="excmcaruserdata_car"-->
<!--            v-model="item.car"-->
<!--            :class="['form-control', isInvalid('car') ? 'is-invalid' : '']"-->
<!--            type="text"-->
<!--            required="true"-->
<!--            placeholder=""-->
<!--            @input="handleUpdateField('car', $event.target.value)">-->
          <fg-input :error="violations.car">
            <el-select
              id="excmcaruserdata_car"
              :class="['select-default', isInvalid('car') ? 'select-danger' : '']"
              :placeholder="$t('views.excmcaruserdata.form.car')"
              filterable
              v-model="item.car">
              <el-option v-for="option in carOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name + ' ' + option.model + ' (' + option.registrationNumber + ')'"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('car')"
            class="invalid-feedback">{{ violations.car }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="form-group">
          <label
            for="excmcaruserdata_dateFrom"
            class="form-control-label">{{$t('views.excmcaruserdata.form.dateFrom')}}:</label>
<!--          <input-->
<!--            id="excmcaruserdata_dateFrom"-->
<!--            v-model="item.dateFrom"-->
<!--            :class="['form-control', isInvalid('dateFrom') ? 'is-invalid' : '']"-->
<!--            type="dateTime"-->
<!--            required="true"-->
<!--            placeholder=""-->
<!--            @input="handleUpdateField('dateFrom', $event.target.value)">-->
          <fg-input :error="violations.dateFrom">
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="item.dateFrom"
              type="date"
              :placeholder="$t('views.excmcaruserdata.form.dateFrom')"
              default-time="12:00:00">
            </el-date-picker>
          </fg-input>
          <div
            v-if="isInvalid('dateFrom')"
            class="invalid-feedback">{{ violations.dateFrom }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="form-group">
          <label
            for="excmcaruserdata_dateTo"
            class="form-control-label">{{$t('views.excmcaruserdata.form.dateTo')}}:</label>
<!--          <input-->
<!--            id="excmcaruserdata_dateTo"-->
<!--            v-model="item.dateTo"-->
<!--            :class="['form-control', isInvalid('dateTo') ? 'is-invalid' : '']"-->
<!--            type="dateTime"-->
<!--            required="true"-->
<!--            placeholder=""-->
<!--            @input="handleUpdateField('dateTo', $event.target.value)">-->
          <fg-input :error="violations.dateTo">
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="item.dateTo"
              type="date"
              :placeholder="$t('views.excmcaruserdata.form.dateTo')"
              default-time="12:00:00">
            </el-date-picker>
          </fg-input>
          <div
            v-if="isInvalid('dateTo')"
            class="invalid-feedback">{{ violations.dateTo }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="item.routePoints && item.routePoints.length > 0" class="mt-3">
      <b-col>
        <b-row>
          <b-col>
            <h6>{{ $t('views.excmcaruserdata.form.routePoints') }}:</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr class="mt-1 mb-1">
          </b-col>
        </b-row>
        <b-row class="mb-2" v-for="(customField, index) in item.routePoints" v-bind:key="'routePoint-' + index">
          <b-col cols="12" lg="6">
            <label
              class="form-control-label">{{$t('views.excmcaruserdata.form.route')}}:</label>
            <input v-model="customField.route" class="form-control">
          </b-col>
          <b-col cols="12" lg="3">
            <label
              class="form-control-label">{{$t('views.excmcaruserdata.form.distance')}}:</label>
            <input type="number" step="any" v-model="customField.distance" class="form-control">
          </b-col>
          <b-col cols="12" lg="3" class="pt-4">
            <b-btn class="btn btn-warning" @click="removeItemCollection(index)">{{ $t('views.excmcaruserdata.form.removeField') }}</b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-btn class="btn btn-success" @click="addNewItemCollection()">{{ $t('views.excmcaruserdata.form.addNewField') }}</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
        <b-btn v-if="$route.name === 'ServicemenShow'" variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
<!--    <div class="form-group">-->
<!--      <label-->
<!--        for="excmcaruserdata_userData"-->
<!--        class="form-control-label">userData</label>-->
<!--      <input-->
<!--        id="excmcaruserdata_userData"-->
<!--        v-model="item.userData"-->
<!--        :class="['form-control', isInvalid('userData') ? 'is-invalid' : '']"-->
<!--        type="text"-->
<!--        required="true"-->
<!--        placeholder=""-->
<!--        @input="handleUpdateField('userData', $event.target.value)">-->
<!--      <div-->
<!--        v-if="isInvalid('userData')"-->
<!--        class="invalid-feedback">{{ violations.userData }}</div>-->
<!--    </div>-->
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    closeModal: {
      type: Function,
      required: function () {
        // console.log()
      }
    }
  },

  computed: {
    ...mapGetters({
      carOptions: 'excmcar/list/items'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getCars()
    this.channelCars = this.$store.state.Pusher.subscribe('e_x_c_m_cars')
    this.channelCars.bind('e_x_c_m_cars', data => {
      this.getCars()
    })
  },

  methods: {
    ...mapActions({
      getCars: 'excmcar/list/default'
    }),
    addNewItemCollection () {
      if (this.item.routePoints === null || this.item.routePoints === undefined || this.item.routePoints.length === undefined) {
        this.item.routePoints = []
      }
      let objectRoutePoint = {
        route: '',
        distance: ''
      }
      this.item.routePoints.push(objectRoutePoint)
    },
    removeItemCollection (itemIndex) {
      this.item.routePoints.splice(itemIndex, 1)
    },

    // getCars () {
    //   let params = {
    //     'pagination': false
    //   }
    //   this.$http
    //     .get('api/e_x_c_m_cars', {
    //       params
    //     })
    //     .then(response => {
    //       this.carOptions = []
    //       this.carOptions = response.data['hydra:member']
    //     })
    //     .catch(error => {
    //       if (error.response.status === 400) {
    //         let text = ''
    //         for (let i in error.response.data) {
    //           text += error.response.data[i] + '\n'
    //         }
    //         this.$Swal({
    //           type: 'warning',
    //           title: text,
    //           timer: 2500
    //         })
    //       }
    //       console.log(error)
    //     })
    // },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
